import React, { useState, useEffect } from "react";
import GenericList from "../components/GenericList";
import {
  getAllRequisitos,
  eliminarRequisito,
} from "../services/requisitos.service";
import { ACTION_BUTTONS } from "../config/constants";
import { Modal as ModalAntd } from "antd";
import Modal from "../components/Modal";
import RequisitosForm from "../components/RequisitosForm";

const RequisitosListPage = () => {
  const [requisitosList, setRequisitosList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [orderByField, setOrderByField] = useState("id");
  const [orderByDirection, setOrderByDirection] = useState("asc");
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalWidth, setModalWidth] = useState("450px");
  const [reload, setReload] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const { confirm } = ModalAntd;

  // Función para obtener los datos
  const fetchRequisitos = async () => {
    const requisitosList = await getAllRequisitos();
    setRequisitosList(requisitosList.data);
  };

  useEffect(() => {
    fetchRequisitos();
  }, [currentPage, currentPageSize, orderByField, orderByDirection, reload]);

  const listColumns = [
    { title: "Nombre", field: "nombre" },
    { title: "Código", field: "codigo" },
    { title: "Oficina", field: "oficina_nombre" },
    { title: "Tipo de respuesta", field: "id_tipo_resultado_nombre" },
    { title: "Procedimiento", field: "procedimiento" },
    { title: "Criterio de validación", field: "validacion" },
  ];

  const listActionButtons = [ACTION_BUTTONS.EDIT, ACTION_BUTTONS.DELETE];

  const onCreateAction = () => {
    setModalTitle(`ALTA DE REQUISITO`);
    setModalContent(
      <RequisitosForm
        setIsVisibleModal={setIsVisibleModal}
        reload={reload}
        setReload={setReload}
        requisito={null}
      />
    );
    setModalWidth("550px");
    setIsVisibleModal(true);
  };

  const onEditAction = (row) => {
    setModalTitle(
      <>
        <p>
          EDICIÓN DE REQUISITO <b>{row.nombre}</b>
        </p>
      </>
    );
    setModalContent(
      <RequisitosForm
        setIsVisibleModal={setIsVisibleModal}
        reload={reload}
        setReload={setReload}
        requisito={row}
      />
    );
    setModalWidth("550px");
    setIsVisibleModal(true);
  };

  const onDeleteAction = (row) => {
    confirm({
      title: (
        <div style={{ textAlign: "center" }}>Eliminación de requisito</div>
      ),
      content: (
        <div style={{ textAlign: "center" }}>
          ¿Estás seguro de eliminar el requisito?
        </div>
      ),
      okText: "Eliminar",
      cancelText: "Cancelar",
      icon: null, // Puedes agregar un ícono personalizado o dejarlo vacío
      okType: "default", // Cambia el estilo del botón Ok
      okButtonProps: {
        style: { float: "left" }, // Mover el botón Ok a la izquierda
      },
      cancelButtonProps: {
        style: { float: "right" }, // Mover el botón Cancel a la derecha
      },
      onOk() {
        return eliminarRequisito(row.id).then(() => {
          setReload(!reload);
        });
      },
    });
  };

  return (
    <>
      <GenericList
        columns={listColumns}
        data={requisitosList}
        actions={listActionButtons}
        onCreateButtonClick={onCreateAction}
        onEditAction={onEditAction}
        onDeleteAction={onDeleteAction}
        title="Lista de Requisitos"
        onPageChange={(page) => {
          setCurrentPage(page + 1);
        }}
        onPageSizeChange={(pageSize) => {
          setCurrentPageSize(pageSize);
        }}
        onOrderChange={(order) => {
          setOrderByField(order[0]?.orderByField);
          setOrderByDirection(order[0]?.orderDirection);
          setReload(!reload);
        }}
      />
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={modalWidth}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default RequisitosListPage;
